/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsseriessignups2Inputs */

const en_statsseriessignups2 = /** @type {(inputs: Statsseriessignups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New accounts`)
};

const de_statsseriessignups2 = /** @type {(inputs: Statsseriessignups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Konten`)
};

/**
* | output |
* | --- |
* | "New accounts" |
*
* @param {Statsseriessignups2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsseriessignups2 = /** @type {((inputs?: Statsseriessignups2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsseriessignups2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsseriessignups2(inputs)
	return de_statsseriessignups2(inputs)
});
export { statsseriessignups2 as "statsSeriesSignups" }